export default __webpack_public_path__ + "static/website_profile_pic-54e32093d48666953c2698561d5dec1d.jpg";